export const createDiscordURL = (username: string) => {
  return `https://discord.com/invite/${username}`;
};
